import React from 'react';
import SireList from 'components/Tvendo/Common/Sire/SireList';
import { ConstantPermissions } from 'contexts/useConstant';

export default function PurchaseSire() {
  return (
    <SireList
      entity="purch/sire"
      title="Compras SIRE"
      permission={ConstantPermissions.PURCH_PURCHASES_INDEX}
    />
  );
}
